import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";

import CashIncomeSessionCard from "../../components/CashIncome/CashIncomeSessionCard";
import CashIncomeHistory from "../../components/CashIncome/CashIncomeHistory";
import CashIncomeModal from "../../components/CashIncome/CashIncomeModal";

const CashIncomePage: React.FC = () => {

  return (

    <DefaultLayout>

      <BreadcrumbTwo />

      <div className="space-y-6">

        {/* Sesión actual */}
        <CashIncomeSessionCard />

        {/* Tabla ingresos */}
        <CashIncomeHistory />

      </div>

      {/* Modal ingreso */}
      <CashIncomeModal />

    </DefaultLayout>

  );

};

export default CashIncomePage;